import PropTypes from 'prop-types';
import { Icon } from 'ui';
import React from 'react';

function HeaderCustom({ left, center, right, className, onClose }) {
  return (
    <div className={`header-custom ${className ? className : ''}`}>
      <div className="header-custom__grid">
        <div className="header-custom__left">{left}</div>
        <div className="header-custom__center">{center}</div>
        <div className="header-custom__right">
          {right}
          {onClose && (
            <div className="header-close__close" onClick={onClose}>
              <Icon name="close" size="xl" color="black" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

HeaderCustom.propTypes = {
  center: PropTypes.node,
  className: PropTypes.string,
  left: PropTypes.node,
  onClose: PropTypes.func,
  right: PropTypes.node,
};

HeaderCustom.defaultProps = {
  center: null,
  className: '',
  left: null,
  onClose: null,
  right: null,
};

export default HeaderCustom;
